import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cursos")({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/cursos" || location.pathname === "/cursos/") {
      throw redirect({ to: "/cursos/empresas" });
    }
  },
  component: () => <Outlet />,
});
